export default "__VITE_PUBLIC_ASSET__c5c0de63__"